import { Avatar, BroadsiderInfo, IconButton } from '../../components';
import { useState } from 'react';
import { StyledBroadsiderHomeSelector } from './BroadsiderHomeSelector.styled';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';
import {
  useNavigate,
} from "react-router-dom";
import { useAccount } from 'wagmi';
import useIsMobile from '../../hooks/useIsMobile';
import { useTokenAuth } from '../../hooks';

const BroadsiderHomeSelector = ({ broadsiders, selectedBroadsider, setSelectedBroadsider }) => {
  const [hoveredBroadsider, setHoveredBroadsider] = useState(null);
  const hoveredId = hoveredBroadsider ? hoveredBroadsider.getId() : null;
  const { setShowLogin, setShowDesktopOnly, setHomepageSelectedAvatarId } = useContext(AppContext);
  const navigate = useNavigate();
  const { isConnected } = useAccount();
  const { user } = useTokenAuth();
  const isMobile = useIsMobile();

  const onClick = () => {
    setHomepageSelectedAvatarId(selectedBroadsider.getId());
    user ? navigate('/app') : isMobile ? setShowDesktopOnly(true) : setShowLogin(true);
  };

  return (
    <StyledBroadsiderHomeSelector>
      <div className='selector-contents'>
        <div className='selector-avatars-holder'>
          {broadsiders.map((f, index) => (<Avatar onMouseLeave={() => setHoveredBroadsider(null)} onMouseEnter={() => setHoveredBroadsider(f)} key={'selec' + index} figure={f} isSelected={f.getId() === selectedBroadsider.getId()} onClick={(figure) => setSelectedBroadsider(figure)} isHovered={hoveredId === f.getId()}/>))}
        </div>
        <div className='selector-info'>
          <BroadsiderInfo broadsider={hoveredBroadsider || selectedBroadsider} />
        </div>
	<div style={{width: '100%'}}>
	  <div className='selector-separator'/>
	</div>
        <IconButton
          animated={true}
          onClick={onClick}>
          <div className='selector-button-content'>
            <img style={{paddingBottom: '6px'}} src='/assets/try_left.svg'/>
            <div>Battle now</div>
            <img style={{paddingBottom: '6px'}} src='/assets/try_right.svg'/>
          </div>
        </IconButton>
      </div>
      <div className='selector-corner selector-corner-tl' />
      <div className='selector-corner selector-corner-tr' />
      <div className='selector-corner selector-corner-bl' />
      <div className='selector-corner selector-corner-br' />
    </StyledBroadsiderHomeSelector>
  );
};

export default BroadsiderHomeSelector;
